/**
 * Strips HTML tags from a string.
 * @param htmlString The HTML string to strip tags from.
 * @returns The plain text string without HTML tags.
 */
export const stripHtml = (htmlString: string) => {
  return htmlString.replace(/<[^>]*>?/gm, "");
};
